import { LOCALE } from '~/translations/translation.types';

const baseUrl = `${
  process.env.BASE_URL
}/web/public/content-store/content/translations-tree/translations`;

class TranslationClient {
  constructor(url) {
    this.url = url;
  }

  translationsPathnameTree(values, acc) {
    return Object.entries(values).reduce((tree, [path, value]) => {
      const paths = path.split('.');
      paths.reduce((deep, chunk, idx) => {
        if (!deep[chunk]) {
          deep[chunk] = idx + 1 < paths.length ? {} : value;
        }
        return deep[chunk];
      }, tree);
      return tree;
    }, acc);
  }

  formatTranslationsTree(result, locale) {
    const translations = result[locale] || {};
    return Object.entries(translations).reduce((map, [section, values]) => {
      map[section] = this.translationsPathnameTree(values, {});
      return map;
    }, {});
  }

  getTranslations = async (locale = LOCALE.RU) => {
    const response = await fetch(this.url + `?filters=${locale}`);
    const result = await response.json();
    return this.formatTranslationsTree(result, locale);
  };
}

export const TranslationService = new TranslationClient(baseUrl);
